import { render } from "./CampoPersonalizadoForm.vue?vue&type=template&id=6589bf7f&scoped=true"
import script from "./CampoPersonalizadoForm.vue?vue&type=script&lang=js"
export * from "./CampoPersonalizadoForm.vue?vue&type=script&lang=js"

import "./CampoPersonalizadoForm.vue?vue&type=style&index=0&id=6589bf7f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6589bf7f"]])

export default __exports__